export default __webpack_public_path__ + "static/bioline-sticky-logo-7bde1715aeb32a09105f8195091f82d1.png";